module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG03916dc42b7c22b5ec14e56013ec1349.03916dc4.png";